import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../firebase/config";
import { collection, query, where, getDocs } from "firebase/firestore";

// Async thunk to fetch favorite products with pagination
export const fetchFavoriteScreenProducts = createAsyncThunk(
  "favoriteScreen/fetchFavoriteScreenProducts",
  async (productIds, { getState }) => {
    const { favoriteScreen } = getState();
    const alreadyLoadedIds = new Set(favoriteScreen.products.map((p) => p.productId));

    const batchIds = productIds.filter((id) => !alreadyLoadedIds.has(id)).slice(0, 10);
    if (batchIds.length === 0) return [];

    const productsRef = collection(db, "products");
    const q = query(productsRef, where("productId", "in", batchIds));
    const querySnapshot = await getDocs(q);

    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  }
);

const favoriteScreenSlice = createSlice({
  name: "favoriteScreen",
  initialState: {
    products: [],
    hasMore: true,
    loading: false,
  },
  reducers: {
    resetFavoriteScreen: (state) => {
      state.products = [];
      state.hasMore = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavoriteScreenProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFavoriteScreenProducts.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.length === 0) {
          state.hasMore = false;
        } else {
          state.products = [...state.products, ...action.payload];
        }
      });
  },
});

export const { resetFavoriteScreen } = favoriteScreenSlice.actions;
export default favoriteScreenSlice.reducer;
